import { Theme } from "@mui/material/styles";
import { SystemStyleObject } from "@mui/system";

const mintNFTStepStyle = {
  button: (theme: Theme): SystemStyleObject<Theme> => ({
    [theme.breakpoints.down("sm")]: {
      minWidth: 150,
      maxWidth: 150,
    },
  }),
};

export default mintNFTStepStyle;
